/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AutocompleteItemDto, AutocompleteItemMapper, ID } from '@gh/common-shared-data';
import {
  AbstractRestService,
  arrayOf,
  emptyOf, identity,
  none,
  optimisticLockingOf,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import { SmsTemplateDetailsDto, SmsTemplateListItemDto } from './sms-templates.dto';
import { SmsTemplateDetailsMapper, SmsTemplateListItemMapper } from './sms-templates.mapper';

@Injectable()
export class SmsTemplateRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  findAllAsDataSource(): SlicedDataSource<SmsTemplateListItemDto> {
    return this.createSlicedDataSourceGet(`${this.bp}/sms-templates`, arrayOf(SmsTemplateListItemMapper));
  }

  findAllAutocompleteItems(): Observable<AutocompleteItemDto[]> {
    return this.httpGet(`${this.bp}/sms-templates/autocomplete`, arrayOf(AutocompleteItemMapper));
  }

  create(details: SmsTemplateDetailsDto): Observable<SmsTemplateDetailsDto> {
    return this.httpPost(`${this.bp}/sms-templates`, details, optimisticLockingOf(SmsTemplateDetailsMapper));
  }

  update(details: SmsTemplateDetailsDto): Observable<SmsTemplateDetailsDto> {
    return this.httpPut(`${this.bp}/sms-templates/${details.id}`, details, optimisticLockingOf(SmsTemplateDetailsMapper));
  }

  get(id: ID): Observable<SmsTemplateDetailsDto> {
    return this.httpGet(`${this.bp}/sms-templates/${id}`, optimisticLockingOf(SmsTemplateDetailsMapper));
  }

  remove(item: SmsTemplateListItemDto): Observable<void> {
    return this.httpDelete(
      `${this.bp}/sms-templates/${item.id}`,
      item,
      emptyOf(optimisticLockingOf(SmsTemplateListItemMapper)),
      none());
  }

  getTemplate(templateId: ID, contactId: any, jobId: any): Observable<any> {
    return this.httpGet(`${this.bp}/sms-templates/${templateId}/filled?${contactId ? 'contactId=' + contactId : ''}&${jobId ? 'jobId=' + jobId : ''}`, identity());
  }

  getSmsTemplates(): Observable<any> {
    return this.httpGet(`${this.bp}/sms-templates/list`, identity());
  }
}
